module.exports = __webpack_public_path__ + "static/media/proveoppgave-1.d2710a2a.mp3";